
import { quickUserRegister, getUtmTrackerId  } from '../../../../lib/helpers/jobHelpers';
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';
import { LOAD_RECOMMENDED_JOBS_EVENT } from '../../../../lib/helpers/common';

export default () => {
  apos.util.widgetPlayers.quickResumeSubmission = {
    selector: '.quick-resume-apply',
    player: async function (quickResumeApply) {

      if (quickResumeApply) {
        const companyData = quickResumeApply.querySelector('#test').dataset;
        const phoneInput = document.querySelector("#phone")
        const config = {
          initialCountry: companyData?.phonedefaultcountry || 'us',
         }
        if (companyData && companyData.countrycodephonenumber) {
          const countries = JSON.parse(
            companyData.countrycodephonenumber
          ).map(c => c.toLowerCase())
          if (countries.length > 0) {
            config.onlyCountries = countries
          }
        }
        const phoneinputobj = window.intlTelInput(phoneInput,config);
        const __t = JSON.parse(quickResumeApply.dataset.localizedValues);
        const recommendedJobsContainer = document.querySelector('#recommended-jobs-container');
        const resumeSubmitOriginChannel = companyData['resumesubmitoriginchannel'];
        console.log("Resume Submit originChannel from CMS config:", resumeSubmitOriginChannel);
        const resumeField = quickResumeApply.querySelector('#quickapply-resume');
        const resumeFieldLabel = quickResumeApply.querySelector('#quickapply-resume-label');
        const multiSelectFields = document.querySelectorAll('.multi-select');
        const singleSelectFields = quickResumeApply.querySelectorAll('.single-select');
        const desiredLocationField = document.querySelector('#desiredlocation-input');
        const urlParams = new URLSearchParams(window.location.search);
        const shortTextField = quickResumeApply.querySelectorAll('.short-text');
        const submitted = urlParams.get('submit');
        let utmTrackerId = null;
        let originType = '08';
        if(submitted === 'true'){
          quickResumeApply.querySelector('#resume-form').remove()
          quickResumeApply.querySelector('#quick-apply-submit').style.display = 'block';
          const fp = document.querySelector('.flatpickr-calendar');
          if(fp){
             fp.style.display = 'none';
          }
        }
        const containsUtmParams = window.location.search.includes('utm_source') || window.sessionStorage.getItem('utm_source');
        if (containsUtmParams) {
          getUtmTrackerId('Job')
            .then(response => {
              utmTrackerId = response;
              window.sessionStorage.setItem('utmTrackerId',utmTrackerId)
            });
        }

        if (resumeField && resumeFieldLabel) {
          resumeField.addEventListener('change', () => {
            if (resumeField.files.length > 0) {
              resumeFieldLabel.innerHTML = `<span>${resumeField.files[0].name}</span>`;
            }
          });
        }
        if (companyData['recaptcharequired'] == "true") {
          window.loadRecaptcha && window.loadRecaptcha("#test");
        }
        const submitForm = quickResumeApply.querySelector('#quickapply-submit');
        const email = quickResumeApply.querySelector('#email');
        const phoneField = quickResumeApply.querySelector('#phone')
        email.addEventListener('keydown', () => {email.setCustomValidity('')});
        phoneField.addEventListener('keydown', () => {phoneField.setCustomValidity('')});

        const data = document.getElementById("api-data").dataset;

        const companyCode = data['companycode'];
        const baseUrl = data['baseurl'];
        if (submitForm) {
          submitForm.addEventListener('click', async () => {
            var phone = '';
            var file = null;
            var terms = false
            var notifications ={ "WHATSAPP": false }
            const captchaErrorMessage = quickResumeApply.querySelector("#captchaErrorMessage");
            if (captchaErrorMessage) {
              captchaErrorMessage.style.display = "none";
            }
            const firstName = quickResumeApply.querySelector('#firstName');
            const lastName = quickResumeApply.querySelector('#lastName');
            const preferredName = quickResumeApply.querySelector('#preferredName')
            const email = quickResumeApply.querySelector('#email');
            const termsField = quickResumeApply.querySelector('#terms');
            const secondaryTermsField = quickResumeApply.querySelector('#terms2');
            const tertiaryTermsField = quickResumeApply.querySelector('#terms3');
            const smOptIn =  quickResumeApply.querySelector('#smOptIn')
            const phoneField = quickResumeApply.querySelector('#phone')
            const city = quickResumeApply.querySelector('#Facility\\.location\\.city');
            const state = quickResumeApply.querySelector('#Facility\\.location\\.state');
            const country = quickResumeApply.querySelector('#Facility\\.location\\.country');
            const address1 = quickResumeApply.querySelector('#Facility\\.location\\.address1');
            const address2 = quickResumeApply.querySelector('#Facility\\.location\\.address2');
            const zipCode = quickResumeApply.querySelector('#Facility\\.location\\.zip');
            const resumeField = quickResumeApply.querySelector('#quickapply-resume');
            const desiredPayId = quickResumeApply.querySelector("#desiredPayCurrency");
            const desiredPay = quickResumeApply.querySelector("#desiredPay");
            const desiredPayUOM = quickResumeApply.querySelector("#desiredPayUOM");
            const currentPayId = quickResumeApply.querySelector("#currentPayCurrency");
            const currentPay = quickResumeApply.querySelector("#currentPay");
            const currentPayUOM = quickResumeApply.querySelector("#currentPayUOM");
            const employmentPreferenceSelect = quickResumeApply.querySelector('#employmentPreferenceSelect');
            const availableToStartWork = quickResumeApply.querySelector('#availabletoStartWork');
            let jobAvailability = "";
            if(availableToStartWork){
                const jobAvailabilityType = quickResumeApply.querySelector('#jobAvailabilityType')?.value;
                if (jobAvailabilityType === "12") {
                  const dateInput = quickResumeApply.querySelector('#jobAvailableDates');
                  if (dateInput && dateInput.value) {
                    const parts = dateInput.value.split("-"); 
                    if (parts.length === 3) {
                      const day = parseInt(parts[0], 10);
                      const month = parseInt(parts[1], 10) - 1; 
                      const year = parseInt(parts[2], 10);
                      const dateObj = new Date(Date.UTC(year, month, day));
                      jobAvailability = dateObj.getTime().toString();
                    }
                  }
                } else {
                  const jobAvailabilitySelect = quickResumeApply.querySelector('#jobAvailability');
                  jobAvailability = jobAvailabilitySelect ? jobAvailabilitySelect.value : "";
                }
            }
            let selectedEmploymentPreferences;
            if(employmentPreferenceSelect){
              selectedEmploymentPreferences = $('#employmentPreferenceSelect').val().join(',');
            }
            const jobSearchStatus = quickResumeApply.querySelector('#jobSearchStatus');
            const remoteSelect = quickResumeApply.querySelector('#remotePreference');
            let remotePreference;
            if(remoteSelect){
              const remoteValue = remoteSelect.value;
              const remoteText = remoteSelect.options[remoteSelect.selectedIndex].getAttribute("data-text");
              remotePreference = [{
                remoteValue: remoteValue,
                remoteText: remoteText
              }];
            } 
            const shiftSelect = quickResumeApply.querySelector('#shiftPreferences');
            let selectedShifts;
            if(shiftSelect){
               selectedShifts = Array.from(shiftSelect.selectedOptions).map(option => option.value);
            }
            const willingToRelocate = quickResumeApply.querySelector('#willingToTravelToggle');
            if (companyData['resumeuploadrequired'] == '01' || companyData['resumeuploadrequired'] == '02' && resumeField.files.length > 0) {
              file = resumeField.files[0];
            }

            const MAX_SIZE = 5242880;
            resumeField.setCustomValidity('');
            if (file && file.size > MAX_SIZE) {
              displayValidationMessage(resumeField, 'Resume file size should be less than 5 MB.')
              return;
            }
            if (companyData['termsandservices'] == "true") {
              terms = termsField.checked
            } 

            var isValidated = validateFields(firstName, lastName, email, phoneField, termsField, resumeField,secondaryTermsField,tertiaryTermsField,multiSelectFields,singleSelectFields,desiredLocationField,desiredPay,desiredPayUOM,currentPay,currentPayUOM)
            if(smOptIn){
               notifications.SMS = smOptIn.checked
            }
            phone = phoneinputobj.getNumber();
            if (isValidated) {
              const userData = {
                userName: email.value,
                firstName: firstName.value,
                preferredName : preferredName?.value || '',
                lastName: lastName.value,
                email: email.value,
                country: country?.value || '',
                state: state?.value || '',
                city: city?.value || '',
                zip: zipCode?.value || '',
                address1 : address1?.value || '',
                address2 : address2?.value || '',
                password: "",
                phone: phone,
                phoneNumberValid: true,
                companyCode: companyCode,
                sourceType: "",
                referralUrl: "",
                referralCode: "",
                userDeviceAppTkn: "",
                duplicateCheckRequired: true,
                isEmailSystemGenerated: true,
                completeRegistration: false,
                userAgreement: terms,
                marketingEmailFlag: false,
                enabled: true,
                notificationTypeMap: notifications,
                workpreference : {
                                  desiredPayId: desiredPayId?.value || '1',
                                  desiredMaxSalary: desiredPay?.value || '0.00',
                                  desiredMinSalary: desiredPay?.value || '0.00',
                                  periodForSalary: desiredPayUOM?.value || '',
                                  currentPay: currentPay?.value || '0.00',
                                  currentPayId: currentPayId?.value || '1',
                                  currentPayUOM: currentPayUOM?.value || '',
                                  employmentPreference: selectedEmploymentPreferences || companyData['workpreferenceparameter'] ||  "",
                                  jobAvailability: jobAvailability || '',
                                  jobSearchStatus: jobSearchStatus?.value || '',
                                  remotePreference: remotePreference || [],
                                  shiftPreferences: selectedShifts || [],
                                  willingToRelocate: willingToRelocate?.checked || false
                                }
              };
              // colleting multiselect field values
              const customData  = {};
              if (multiSelectFields ){
              multiSelectFields.forEach(select => {
                  const name = select.dataset["name"];
                  let selectedOptionData = Array.from(select.selectedOptions).map(option => option.value);
                  selectedOptionData = selectedOptionData.join(",");
                  customData [name] = selectedOptionData;
              }); 
              if(singleSelectFields){
                singleSelectFields.forEach(select => {
                  const name = select.dataset["name"];
                  const value = select.value;
                  customData[name] = value; 
              });
            }
          }
            //
              // collecting short field text
              if(shortTextField){
              shortTextField.forEach(field => {
              const shortTextFieldName = field?.dataset.name;
              const shortTextFieldValue = field?.value;

              customData[shortTextFieldName] = shortTextFieldValue;
              });}

              const formData = new FormData();
              formData.append('user', JSON.stringify(userData));
              if (resumeSubmitOriginChannel) {
                console.log("Appending originChannel to resume submit:", resumeSubmitOriginChannel);
                formData.append('originChannel', resumeSubmitOriginChannel);
              }
              if (file != null) {
                formData.append('resumefile', file);
              }
              formData.append('resume', '{"resumename":"","resumeLink":"",jobpostingid":' + null + '}')
              formData.append('context', 'QUICK_APPLY');
              if (utmTrackerId) {
                formData.append('utmTrackerId', utmTrackerId);
              }
              const isMeetYouRecruiterPage = window.location.pathname.includes('/profiles');
              if(isMeetYouRecruiterPage){
                formData.append('originType', originType);
              }
              const recommendedJobsOptions = {
                enabled: Boolean(recommendedJobsContainer),
                minScore: recommendedJobsContainer && recommendedJobsContainer.dataset.minScore,
                limit: recommendedJobsContainer && recommendedJobsContainer.dataset.limit
              };
              formData.append('matchJobs',recommendedJobsOptions.enabled)
              // if((multiSelectFields && multiSelectFields.length > 0) || (singleSelectFields && singleSelectFields.length > 0)){
              formData.append("customData" , JSON.stringify(customData));
              formData.append( "desiredLocations", companyData['selectedlocations']);
              const formDataObj = {};
              formData.forEach((value, key) => {
                formDataObj[key] = value;
              });
                logWLAnalyticsEvent(`Resume Submit Button Clicked`, {
                  phoneNumber: phone.replace(/\D/g, '').slice(-4),
                });
                var overlay = document.querySelector("#quick-apply-overlay-spinner");
                overlay.style.display = 'block';
              // var overlay = document.querySelector("#quick-apply-overlay");
              var spinner = document.querySelector('#quick-apply-spinner')
              var response = await quickUserRegister(formData, recommendedJobsOptions);
              if (response.success === true) {
                overlay.style.display = 'none';
                // spinner.style.display = 'none';
                quickResumeApply.querySelector('#firstName').value = '';
                quickResumeApply.querySelector('#lastName').value = '';
                quickResumeApply.querySelector('#email').value = '';
                quickResumeApply.querySelector('#phone').value = '';
                if (singleSelectFields) {
                  $(singleSelectFields).each(function () {
                    $(this).val(null).trigger('change');
                  });
                }
                if (companyData['resumeuploadrequired'] == '01' || companyData['resumeuploadrequired'] == '02' && quickResumeApply.querySelector('#quickapply-resume').files.length > 0) {
                  quickResumeApply.querySelector('#quickapply-resume').value = null;
                }
                if (companyData['termsandservices'] == "true") {
                  termsField.checked = false;
                }
                if( secondaryTermsField){
                  secondaryTermsField.checked = false;
                }
                if(tertiaryTermsField){
                  tertiaryTermsField.checked = false;
                }
                // quickResumeApply.querySelector('#resume-form').remove()
                // quickResumeApply.querySelector('#quick-apply-submit').style.display = 'block';
                // showSuccessMessage('Submit your Resume', 'Resume submitted successfully!');
                
                // in container exist is because is enabled at widget level
                if (recommendedJobsContainer) {
                  // TODO check when error response
                  recommendedJobsContainer.style.display = null;
                  recommendedJobsContainer
                    .querySelector('.recommended-jobs-widget')
                    .dispatchEvent(new Event(LOAD_RECOMMENDED_JOBS_EVENT));
                }

                // Track Resume Submitt Event
                logWLAnalyticsEvent(`Resume Uploaded`, {
                  userId: response.userId,
                });
                const url = new URL(window.location.href);
                url.searchParams.set('submit', 'true');
                window.location.href = url.origin + url.pathname + url.search;
              }
              else {
                overlay.style.display = 'none';
                spinner.style.display = 'none';
                const errorMessage = response.split('.')[0];
                if (!errorMessage) return false;
                showErrorMessage('Submit your Resume', errorMessage);
                const lowerErrorMessage = errorMessage.toLowerCase();
                if (lowerErrorMessage.indexOf('this email address is already in use') >= 0) {
                  quickResumeApply.querySelector('#resume-form').remove()
                  quickResumeApply.querySelector('#quick-apply-existing-user').style.display = 'block';
                } else if (lowerErrorMessage.indexOf('email') >= 0) {
                  displayValidationMessage(quickResumeApply.querySelector('#email'), errorMessage);
                } else if (lowerErrorMessage.indexOf('phone') >= 0) {
                  displayValidationMessage(quickResumeApply.querySelector('#phone'), errorMessage);
                } else if (lowerErrorMessage.indexOf('first name') >= 0) {
                  displayValidationMessage(quickResumeApply.querySelector('#firstName'), errorMessage);
                } else if (lowerErrorMessage.indexOf('last name') >= 0) {
                  displayValidationMessage(quickResumeApply.querySelector('#lastName'), errorMessage);
                }else if (lowerErrorMessage.indexOf('resume') >= 0) {
                  displayValidationMessage(resumeField, response);
                }
                const fp = document.querySelector('.flatpickr-calendar');
                if(fp){
                  fp.style.display = 'none';
                }           
              }
            }
            return false;
          });

        }
        function validateFields(firstName, lastName,email,phoneField, termsField, resumeField,secondaryTermsField ,tertiaryTermsField,multiSelectFields,singleSelectFields,desiredLocationField,desiredPay,desiredPayUOM,currentPay,currentPayUOM) {
          // phoneField
          var allowedTypes = companyData['resumetypesallowed'].split(",")

          firstName.setCustomValidity('');
          lastName.setCustomValidity('');
          email.setCustomValidity('');
          phoneField.setCustomValidity('');
          resumeField.setCustomValidity('');
          
          if(secondaryTermsField){
          secondaryTermsField.setCustomValidity('');
          }
          if(tertiaryTermsField){
          tertiaryTermsField.setCustomValidity('');
          }

          if(desiredLocationField){
            desiredLocationField.setCustomValidity('');
          }

          if (!(firstName.value.length > 0)) {
            displayValidationMessage(firstName, __t['referAFriend.firstNameRequired']);
            return false
          }

          if (!(lastName.value.length > 0)) {
            displayValidationMessage(lastName, __t['referAFriend.lastNameRequired']);
            return false
          }
          
          if (!(email.value.length > 0 && validateEmail(email.value))) {
            displayValidationMessage(email, email.value.length ? __t['global.emailErrorInvalid'] : __t['global.emailErrorRequired']);
            return false
          }
      
          if (!(phoneField.value.length > 0 && phoneinputobj.isValidNumber())) {
            displayValidationMessage(phoneField, phoneField.value.length ? __t['quickApply.phoneErrorInvalid'] : __t['quickApply.phoneErrorRequired']);
            return false
          }  

          if (companyData['resumeuploadrequired'] === '01') {
            if (resumeField.files.length > 0) {
              if (!allowedTypes.includes(resumeField.files[0].type)) {
                displayValidationMessage(resumeField, __t['quickApply.resumeErrorInvalid']);
                return false;
              }
            }
            else {
              showWarningMessage('Submit your Resume', 'Please upload a resume');
              displayValidationMessage(resumeField, __t['quickApply.resumeErrorRequired']);
              return false;
            }
          }
          else if (companyData['resumeuploadrequired'] === '02' && resumeField.files.length > 0) {
            if (!allowedTypes.includes(resumeField.files[0].type)) {
              displayValidationMessage(resumeField, __t['quickApply.resumeErrorInvalid']);
              return false;
            }
          }

          if (desiredLocationField){
            if(companyData['selectedlocations'] === '[]'){
                 displayValidationMessage(desiredLocationField, 'Please select atleast one drop down value');
                 setTimeout(() => {
                     desiredLocationField.setCustomValidity('');
                },2000);
                 return false;
            }
          }
          if (desiredPay && desiredPay.value === "" && desiredPayUOM && desiredPayUOM.value !== "") {
            displayValidationMessage(desiredPay, 'Please enter desired pay');
            setTimeout(() => desiredPay.setCustomValidity(''), 3000);
            return false;
          }
          if (desiredPay && desiredPay.value !== "" && desiredPayUOM && desiredPayUOM.value === "") {
            displayValidationMessage(desiredPayUOM, 'Please select UOM');
            setTimeout(() => desiredPayUOM.setCustomValidity(''), 3000);
            return false;
          }
          if (currentPay && currentPay.value === "" && currentPayUOM && currentPayUOM.value !== "") {
            displayValidationMessage(currentPay, 'Please enter current pay');
            setTimeout(() => currentPay.setCustomValidity(''), 3000);
            return false;
          }
          if (currentPay && currentPay.value !== "" && currentPayUOM && currentPayUOM.value === "") {
            displayValidationMessage(currentPayUOM, 'Please select UOM');
            setTimeout(() => currentPayUOM.setCustomValidity(''), 3000);
            return false;
          }

           if(multiSelectFields && multiSelectFields.length > 0){
            let answered=true;
             multiSelectFields.forEach(item => {
            item.setCustomValidity('');
            item.parentElement?.querySelector('input')?.setCustomValidity('');
            const required = item.dataset["required"];
            const selectedOptionData = Array.from(item.selectedOptions).map(option => option.value);
            if(required && selectedOptionData.length === 0){
              displayValidationMessage(item.parentElement.querySelector('input'), 'Please select atleast one drop down value');
            answered= false;
            return
            }
            });
            if (!answered) return answered;
          }
          if (singleSelectFields && singleSelectFields.length > 0){
            let allValid = true;
            singleSelectFields.forEach(item => {
              item.setCustomValidity('');
              item.parentElement?.querySelector('input')?.setCustomValidity('');
              const required = item.dataset["required"] === "true" || item.dataset["required"] === "1";
              const value = item.value;

              if (required && (!value || value.trim() === '')) {
                displayValidationMessage(item.parentElement.querySelector('input'), 'Please select a value.');
                allValid = false;
              }
            });

            if (!allValid) return false;
          }

          if (companyData['termsandservices'] == "true") {
            termsField.setCustomValidity('');
            if (!termsField.checked) {
              displayValidationMessage(termsField, __t['quickApply.termsRequired']);
              return false;
            }
          }
          if( secondaryTermsField && !secondaryTermsField.checked){
            displayValidationMessage(secondaryTermsField, __t['quickApply.termsRequired']);
            return false;
          }
          if( tertiaryTermsField && !tertiaryTermsField.checked){
            displayValidationMessage(tertiaryTermsField, __t['quickApply.termsRequired']);
            return false;
          }

          if (companyData['recaptcharequired'] == "true") {
             if (
              !(window.grecaptcha && window.grecaptcha.getResponse().length !== 0) &&
              captchaErrorMessage
            ) {
              captchaErrorMessage.style.display = "block";
              return false;
            }
          }
          
          // displayValidationMessage(window.grecaptcha ,__t['quickApply.recaptchaRequired']);
          return true;
        }

        function validateEmail(email) {
          return String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        };
        function formatPhoneNumber(value, country) {
          let digits = value.replace(/\D/g, "");
          const maxLength = getMaxLength(country);
          digits = digits.slice(0, maxLength);
          const formatter = new libphonenumber.AsYouType(country);
          return formatter.input(digits);          
        }
        
        function getMaxLength(country) {
          const metadata = new libphonenumber.Metadata();
          metadata.selectNumberingPlan(country);
          const possibleLengths = metadata.numberingPlan.possibleLengths();
          return Math.max(...possibleLengths);
        }


        function reformatPhone() {
          const selected = phoneinputobj.getSelectedCountry()?.iso2?.toUpperCase();
           const fallback = companyData.phonedefaultcountry?.toUpperCase();
          const country = selected || fallback;
          let digits = phoneField.value.replace(/\D/g, "");    
          digits = digits.substring(0, getMaxLength(country));
          const formatter = new libphonenumber.AsYouType(country);
          phoneField.value = formatter.input(digits);
        }

        phoneField.addEventListener("input", reformatPhone);
        phoneField.addEventListener("countrychange", reformatPhone);

        function showErrorMessage(title, message) {
          showMessage(title, message, 'error');
        }
        function showWarningMessage(title, message) {
          showMessage(title, message, 'warning');
        }
        function showSuccessMessage(title, message) {
          showMessage(title, message, 'success');
        }
        function showInfoMessage(title, message) {
          showMessage(title, message, 'info');
        }

        function showMessage(title, message, type) {
          console.log(type, title, message);
        }

        function displayValidationMessage(field, message) {
          try {
            field.focus();
            setTimeout(() => {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
            },700);
          } catch (err) {
            console.log(err);
          }
        }
        // custom field multiselect jquery starts here
        // $(document).ready(function () {
        //   const $select = $('.multi-select');
        //   const $output = $('#selected-values');
    
        //   $select.select2({
        //     placeholder: 'Select options',
        //     closeOnSelect: true,
        //     dropdownPosition: 'below'
        //   });
        //   function renderSelected() {
        //     const selected = $select.select2('data');
        //     $output.empty();
    
        //     selected.forEach(item => {
        //       const html = `
        //         <div class="selected-item" data-value="${item.id}">
        //           ${item.text}
        //           <span class="remove-btn" title="Remove" data-value="${item.id}">&times;</span>
        //         </div>
        //       `;
        //       $output.append(html);
        //     });
    
        //     // Handle remove clicks
        //     $('.remove-btn').on('click', function () {
        //       const valueToRemove = $(this).data('value');
        //       let currentValues = $select.val() || [];
        //       currentValues = currentValues.filter(val => val !== valueToRemove);
        //       $select.val(currentValues).trigger('change');
        //     });
        //   }
        //   renderSelected();
        //   $select.on('change', renderSelected);
        // });

        $(document).ready(function () {
        function initializeMultiSelect($select) {
          const outputSelector = $select.data('output'); // Get the ID of the output container
          const $output = $(outputSelector);
          const label = $(`label[for="${$select.attr('id')}"]`).text().trim();
          const placeholderText = label
            ? label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()
            : 'Select options';

          $select.select2({
            placeholder: placeholderText,
            closeOnSelect: true,
            dropdownPosition: 'below'
          });

          function renderSelected() {
            const selected = $select.select2('data');
            $output.empty();

            selected.forEach(item => {
              const html = `
                <div class="selected-item" data-value="${item.id}">
                  ${item.text}
                  <span class="remove-btn" title="Remove" data-value="${item.id}">&times;</span>
                </div>
              `;
              $output.append(html);
            });

            // Handle remove clicks inside this output container only
            $output.find('.remove-btn').on('click', function () {
              const valueToRemove = $(this).data('value');
              let currentValues = $select.val() || [];
              currentValues = currentValues.filter(val => val !== valueToRemove);
              $select.val(currentValues).trigger('change');
            });
          }

              // Initial render and on-change binding
            renderSelected();
              $select.on('change', renderSelected);
            }

            $('.multi-select').each(function () {
              initializeMultiSelect($(this));
            });

            $('.single-select').each(function () {
              const selectId = $(this).attr('id');
              let placeholderText = 'Please select'; 
              if (selectId) {
                const labelText = $(`label[for="${selectId}"]`).text().trim();
                if (labelText) {
                  placeholderText = labelText.charAt(0).toUpperCase() + labelText.slice(1).toLowerCase();
                }
              }
              $(this).select2({
                placeholder: placeholderText,
                allowClear: true,
                minimumResultsForSearch: Infinity
              });
            });  
        });
        



      }
    }
  }

}
